module.exports = __webpack_public_path__ + "img/menuIcon3.54c9cc2a.png";